import { createApp } from 'vue'
import FundRaisingCounter from './FundRaisingCounter'

const el = '.kb-component--fund-raising-counter'

export default function (Store) {
    const DOM = document.querySelectorAll(el)

    if (DOM.length) {
        DOM.forEach((FundRaisingCounterDOM) => {
            const dataset = FundRaisingCounterDOM.dataset

            const props = {
                title: dataset.title,
                description: dataset.description,
                centerImage: JSON.parse(
                    dataset.centerImage || '[]'
                ),
                nonCenteredImages: JSON.parse(
                    dataset.noncenteredImages || '[]'
                ),
                linkUrl: dataset.linkUrl,
                linkText: dataset.linkText,
                linkTitle: dataset.linkTitle,
                linkTarget: dataset.linkTarget,
                campaignId: dataset.campaignId
            }
            const component = createApp(FundRaisingCounter, props).use(Store)
            component.mount(FundRaisingCounterDOM)
        })
    }
}
